export default "__VITE_ASSET__BmwYng_B__"